import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { formatNumbers } from 'core/helpers/format-numbers'
import { routes } from 'core/routes/paths'
import { useAuthContext } from '../../core/providers/AuthProvider'
import { useSocketNotifications } from '../../core/hooks'

import avatar from './assets/images/avatar.png'

import c from './assets/sass/header.module.scss'

export const Header = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { user, isAuthenticated } = useAuthContext()

    useSocketNotifications((notification) => {
        if (notification.type === 'balance_updated') {
        }
    })

    const displayName =
        isAuthenticated && user
            ? user.username || user.firstName || t('header.player')
            : 'Goldenplug'

    const userAvatar =
        isAuthenticated && user ? user.photoUrl || avatar : avatar

    const balance =
        isAuthenticated && user ? parseInt(user.balance) || 0 : 10930491

    return (
        <div className={c.component}>
            <div className={c.left}>
                <div className={cn(c.row, c.leftRow)}>
                    <div
                        className={c.user}
                        onClick={() => isAuthenticated && navigate(routes.userProfile)}
                        role="button"
                        tabIndex={0}
                    >
                        <img src={userAvatar} alt="User" />
                        <span>{displayName}</span>
                    </div>
                </div>
            </div>
            <div className={c.right}>
                <div className={cn(c.row, c.rightRow)}>
                    <div className={c.balance}>
                        <span>{formatNumbers(balance)}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
